import { Root, Thumb, SwitchProps } from "@radix-ui/react-switch";

export const Switch = ({ ...props }: SwitchProps) => {
  return (
    <Root
      {...props}
      className="shadow-blackA4 relative h-[25px] w-[42px] cursor-pointer
      rounded-full bg-item-secondary outline-none data-[state=checked]:bg-highlightPrimary"
    >
      <Thumb className="block h-[21px] w-[21px] translate-x-0.5 rounded-full bg-surface-primary transition-transform duration-100 will-change-transform data-[state=checked]:translate-x-[19px]" />
    </Root>
  );
};
